import { getApiCall, postApiCall } from "./tokenService";
import { LogListItems } from "../log/logListItems";
import { LogPage } from "../log/logPage";
import { LogProperties } from "../log/logProperties";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";

// #region LogPage
export const getLogPage = (): Promise<LogPage> => {
    return getApiCall("api/log", LogPage);
};

export const getLogListItems = (companyId: string, pageSize: number, page: number, filter: string, types: number[], timeSpan: number, startDate: number, endDate: number, sortColumn: string, sortOrderIsAsc: boolean): Promise<LogListItems> => {
    return postApiCall("api/log/list", LogListItems, JSON.stringify({
        companyId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        types,
        timeSpan,
        startDate: startDate || null,
        endDate: endDate || null
    }));
};
// #endregion LogPage

// #region Module properties
export const getLogProperties = (companyId: string): Promise<LogProperties> => {
    return getApiCall("api/log/properties?id=" + companyId, LogProperties);
};

export const saveLogProperties = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/log/saveproperties", ApiSuccess, JSON.stringify(obj));
};

export const clearLog = (): Promise<ApiSuccess> => {
    return postApiCall("api/log/clear", ApiSuccess);
};
// #endregion Module properties